import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TodayIcon from '@mui/icons-material/Today';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DraftsIcon from '@mui/icons-material/Drafts';
import { BarChart } from '@mui/icons-material';

export default function PostsStatsCards({ stats }) {
  return (
<Box
  sx={{
    display: 'flex',
    justifyContent: 'center',
    mb: 2,
  }}
>
  <Box
    sx={{
      display: 'flex',
      gap: 1,
      flexWrap: 'wrap',
      justifyContent: { xs: 'stretch', sm: 'center' },
      px: { xs: 0, sm: 2 },
      width: '100%',
      maxWidth: '100%',
      overflowX: 'auto',
    }}
  >
    <Card
      sx={{
        width: { xs: 'calc(50% - 4px)', sm: 160 },
        minWidth: { xs: 0, sm: 160 },
        height: 120,
        flex: { xs: '1 1 calc(50% - 4px)', sm: '0 0 160px' },
      }}
    >
      <CardContent
        sx={{
          p: 2,
          '&:last-child': { pb: 2 },
          textAlign: 'center',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
            mb: 1,
          }}
        >
          <ScheduleIcon color="primary" sx={{ fontSize: 18 }} />
          <Typography
            variant="body2"
            sx={{ fontSize: '0.75rem', fontWeight: 600 }}
          >
            Scheduled
          </Typography>
        </Box>
        <Typography variant="h5" sx={{ mb: 0.5, textAlign: 'center' }}>
          {stats.scheduled}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontSize: '0.75rem',
            lineHeight: 1.2,
            textAlign: 'center',
          }}
        >
          Posts waiting to be published
        </Typography>
      </CardContent>
    </Card>
    <Card
      sx={{
        width: { xs: 'calc(50% - 4px)', sm: 160 },
        minWidth: { xs: 0, sm: 160 },
        height: 120,
        flex: { xs: '1 1 calc(50% - 4px)', sm: '0 0 160px' },
      }}
    >
      <CardContent
        sx={{
          p: 2,
          '&:last-child': { pb: 2 },
          textAlign: 'center',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
            mb: 1,
          }}
        >
          <TrendingUpIcon color="success" sx={{ fontSize: 18 }} />
          <Typography
            variant="body2"
            sx={{ fontSize: '0.75rem', fontWeight: 600 }}
          >
            Published
          </Typography>
        </Box>
        <Typography variant="h5" sx={{ mb: 0.5, textAlign: 'center' }}>
          {stats.published}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontSize: '0.75rem',
            lineHeight: 1.2,
            textAlign: 'center',
          }}
        >
          Posts published
        </Typography>
      </CardContent>
    </Card>
    <Card
      sx={{
        width: { xs: 'calc(50% - 4px)', sm: 160 },
        minWidth: { xs: 0, sm: 160 },
        height: 120,
        flex: { xs: '1 1 calc(50% - 4px)', sm: '0 0 160px' },
      }}
    >
      <CardContent
        sx={{
          p: 2,
          '&:last-child': { pb: 2 },
          textAlign: 'center',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
            mb: 1,
          }}
        >
          <TodayIcon color="warning" sx={{ fontSize: 18 }} />
          <Typography
            variant="body2"
            sx={{ fontSize: '0.75rem', fontWeight: 600 }}
          >
            Today's Posts
          </Typography>
        </Box>
        <Typography variant="h5" sx={{ mb: 0.5, textAlign: 'center' }}>
          {stats.today}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontSize: '0.75rem',
            lineHeight: 1.2,
            textAlign: 'center',
          }}
        >
          Scheduled for today
        </Typography>
      </CardContent>
    </Card>
    <Card
      sx={{
        width: { xs: 'calc(50% - 4px)', sm: 160 },
        minWidth: { xs: 0, sm: 160 },
        height: 120,
        flex: { xs: '1 1 calc(50% - 4px)', sm: '0 0 160px' },
      }}
    >
      <CardContent
        sx={{
          p: 2,
          '&:last-child': { pb: 2 },
          textAlign: 'center',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
            mb: 1,
          }}
        >
          <CalendarTodayIcon color="info" sx={{ fontSize: 18 }} />
          <Typography
            variant="body2"
            sx={{ fontSize: '0.75rem', fontWeight: 600 }}
          >
            This Week
          </Typography>
        </Box>
        <Typography variant="h5" sx={{ mb: 0.5, textAlign: 'center' }}>
          {stats.week}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontSize: '0.75rem',
            lineHeight: 1.2,
            textAlign: 'center',
          }}
        >
          Scheduled this week
        </Typography>
      </CardContent>
    </Card>
    <Card
      sx={{
        width: { xs: 'calc(50% - 4px)', sm: 160 },
        minWidth: { xs: 0, sm: 160 },
        height: 120,
        flex: { xs: '1 1 calc(50% - 4px)', sm: '0 0 160px' },
      }}
    >
      <CardContent
        sx={{
          p: 2,
          '&:last-child': { pb: 2 },
          textAlign: 'center',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
            mb: 1,
          }}
        >
          <ErrorOutlineIcon color="error" sx={{ fontSize: 18 }} />
          <Typography
            variant="body2"
            sx={{ fontSize: '0.75rem', fontWeight: 600 }}
          >
            Failed
          </Typography>
        </Box>
        <Typography variant="h5" sx={{ mb: 0.5, textAlign: 'center' }}>
          {stats.failed}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontSize: '0.75rem',
            lineHeight: 1.2,
            textAlign: 'center',
          }}
        >
          Failed to publish
        </Typography>
      </CardContent>
    </Card>
    <Card
      sx={{
        width: { xs: 'calc(50% - 4px)', sm: 160 },
        minWidth: { xs: 0, sm: 160 },
        height: 120,
        flex: { xs: '1 1 calc(50% - 4px)', sm: '0 0 160px' },
      }}
    >
      <CardContent
        sx={{
          p: 2,
          '&:last-child': { pb: 2 },
          textAlign: 'center',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
            mb: 1,
          }}
        >
          <AutorenewIcon color="secondary" sx={{ fontSize: 18 }} />
          <Typography
            variant="body2"
            sx={{ fontSize: '0.75rem', fontWeight: 600 }}
          >
            Recurring
          </Typography>
        </Box>
        <Typography variant="h5" sx={{ mb: 0.5, textAlign: 'center' }}>
          {stats.recurring}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontSize: '0.75rem',
            lineHeight: 1.2,
            textAlign: 'center',
          }}
        >
          Active recurring posts
        </Typography>
      </CardContent>
    </Card>
    <Card
      sx={{
        width: { xs: 'calc(50% - 4px)', sm: 160 },
        minWidth: { xs: 0, sm: 160 },
        height: 120,
        flex: { xs: '1 1 calc(50% - 4px)', sm: '0 0 160px' },
      }}
    >
      <CardContent
        sx={{
          p: 2,
          '&:last-child': { pb: 2 },
          textAlign: 'center',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
            mb: 1,
          }}
        >
          <DraftsIcon color="action" sx={{ fontSize: 18 }} />
          <Typography
            variant="body2"
            sx={{ fontSize: '0.75rem', fontWeight: 600 }}
          >
            Drafts
          </Typography>
        </Box>
        <Typography variant="h5" sx={{ mb: 0.5, textAlign: 'center' }}>
          {stats.drafts}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontSize: '0.75rem',
            lineHeight: 1.2,
            textAlign: 'center',
          }}
        >
          Unscheduled drafts
        </Typography>
      </CardContent>
    </Card>
    <Card
      sx={{
        width: { xs: 'calc(50% - 4px)', sm: 160 },
        minWidth: { xs: 0, sm: 160 },
        height: 120,
        flex: { xs: '1 1 calc(50% - 4px)', sm: '0 0 160px' },
      }}
    >
      <CardContent
        sx={{
          p: 2,
          '&:last-child': { pb: 2 },
          textAlign: 'center',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
            mb: 1,
          }}
        >
          <BarChart color="primary" sx={{ fontSize: 18 }} />
          <Typography
            variant="body2"
            sx={{ fontSize: '0.75rem', fontWeight: 600 }}
          >
            Engagement
          </Typography>
        </Box>
        <Typography variant="h5" sx={{ mb: 0.5, textAlign: 'center' }}>
          {stats.engagement}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontSize: '0.75rem',
            lineHeight: 1.2,
            textAlign: 'center',
          }}
        >
          Avg. engagement/post
        </Typography>
      </CardContent>
    </Card>
  </Box>
</Box>
  );
}
